export default class HttpNotifier {
	constructor() {
		// total de requests ao mesmo tempo
		this.requestCount = 0;
		this.handlers = {};
		this.timeoutHandler = 0;
		this.loading = false;
	}

	register() {
		this.requestCount += 1;
		if (this.requestCount == 1 && this.timeoutHandler == 0) {
			this.timeoutHandler = setTimeout( () => {
				this.loading = true;
				this.raiseEvents();
			}, 100);
		}
	}

	unregister() {
		this.requestCount -= 1;
		if (this.requestCount <= 0) {
			if (this.timeoutHandler > 0) {
				clearTimeout(this.timeoutHandler);
				this.timeoutHandler = 0;
			}
			this.requestCount = 0;
			if (this.loading) {
				this.loading = false;
				this.raiseEvents();
			}
		}
	}

	addHandler(handler) {
		let idx = Object.keys(this.handlers).length;
		this.handlers[idx] = handler;
		return idx;
	}

	removeHandler(handlerIdx) {
		if (this.handlers.hasOwnProperty(handlerIdx)) {
			delete this.handlers[handlerIdx];
		}
	}

	raiseEvents() {
		setTimeout( () => {
			for (var i in this.handlers) {
				this.handlers[i](this.loading);
			}
		});
	}
}
